export const parseFromStripe = stripeStructure => {
    const {
        amount_due,
        created,
        period_end,
        period_start,
        subtotal,
        discount,
        total_discount_amounts,
        total_excluding_tax,
        tax,
        total,
        lines,
        ending_balance,
        starting_balance,

    } = stripeStructure;

    const newLineDatas = lines.data.map(
        ({
            description,
            amount,
            amount_excluding_tax,
            period, plan, quantity,
            discountable, discount_amounts,
        }) => ({

            // description: "Remaining time on Subscription (Monthly) after 10 Sep 2023",
            // quantity: 1,
            // start_time: '2023-09-11 00:00:00',
            // end_time: '2023-09-29 16:33:36',
            // plan_unit_amount: 99,
            // amount: 59.69,
            // amount_excluding_tax: 59.69,
            // product_name: "Premium",

            description,
            quantity,
            discountable,
            discount_amount: discount_amounts.reduce(
                (acc, { amount }) => acc + amount,
                0,
            ) / 100,
            // start_time: new Date(period.start * 1000).toISOString(),
            // end_time: new Date(period.end * 1000).toISOString(),
            period: {
                start: new Date(period.start * 1000).toISOString(),
                end: new Date(period.end * 1000).toISOString(),
            },
            plan_unit_amount: plan.amount / 100,
            amount: amount / 100,
            amount_excluding_tax: amount_excluding_tax / 100,
            product_name: plan.nickname || plan.product || 'Unknown',

            // plan,
            // price,
            // unit_amount_excluding_tax,
            // // period,
            // plan_name: plan.nickname,
            // price_unit_amount: price.unit_amount,
        }),
    );

    const nextSubscriptionItem = newLineDatas.find(({ description }) => !description.includes('Unused'));
    const {
        price,
    } = nextSubscriptionItem || {};
    const newBillingCycle = (price?.recurring.interval === 'month' ? 1 : 12) * (price?.recurring.interval_count || 1);

    return {
        subtotal: subtotal / 100,
        discount: {
            code: discount?.coupon?.name, // eg: 'GROWTH31' from stripe - discount.coupon.name or db coupon.code
            amount_off: discount?.coupon?.amount_off, // from stripe (eg: when deduct value eg -RM5)
            percent_off: discount?.coupon?.percent_off, // from stripe (eg: when deduct percentage eg 20% off)
        },
        discount_amount: total_discount_amounts.reduce(
            (acc, { amount }) => acc + amount,
            0,
        ) / 100,
        total_excluding_tax: total_excluding_tax / 100,
        tax_amount: tax / 100,
        total: total / 100,
        amount_due: amount_due / 100,
        billing_cycle: newBillingCycle, // process from recurring.interval_count
        proration_start_date: new Date(period_start * 1000).toISOString(), // from period_start
        proration_end_date: new Date(period_end * 1000).toISOString(), // from period_end
        first_billing_date: new Date(created * 1000).toISOString(), // from created (try with always_invoice vs create_prorations
        prices: newLineDatas,
        credits: {
            starting_balance: starting_balance / 100,
            ending_balance: ending_balance / 100,
            applied_balance: (starting_balance - ending_balance) / 100,
        },
    };
};
